import { Controller } from "@hotwired/stimulus"
import { longFormatters } from "date-fns"

export default class extends Controller {
    static targets = ["tocLink"]

    connect() {
        // Handle direct links (when someone shares a URL with #section-id)
        this.scrollToHashOnLoad()

        // Update active link on scroll with throttling
        this.handleScroll = this.throttle(this.updateActiveSection.bind(this), 100)
        window.addEventListener('scroll', this.handleScroll, { passive: true })

        // Set initial active section
        this.updateActiveSection()
    }

    disconnect() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    scrollToSection(event) {
        event.preventDefault()

        const targetId = event.currentTarget.getAttribute('href').substring(1)
        const targetElement = document.getElementById(targetId)

        if (targetElement) {
            // Smooth scroll to the section with offset for fixed header
            const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 100

            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            })

            // Update URL without triggering page reload
            history.pushState(null, null, `#${targetId}`)

            // Wait for scroll to complete, then update active state
            setTimeout(() => {
                this.updateActiveSection()
            }, 500)
        }
    }

    scrollToHashOnLoad() {
        const hash = window.location.hash
        if (hash) {
            setTimeout(() => {
                const targetId = hash.substring(1)
                const targetElement = document.getElementById(targetId)

                if (targetElement) {
                    const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 100

                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    })

                    setTimeout(() => {
                        this.updateActiveSection()
                    }, 500)
                }
            }, 100)
        }
    }

    updateActiveSection() {
        const headings = document.querySelectorAll('h2[id], h3[id]')

        if (headings.length === 0) {
            return
        }

        let currentHeading = null
        const scrollPosition = window.scrollY + 150

        headings.forEach(heading => {
            const headingPosition = heading.offsetTop
            if (headingPosition <= scrollPosition) {
                currentHeading = heading
            }
        })

        if (!currentHeading && scrollPosition < 200) {
            currentHeading = headings[0]
        }

        if (currentHeading) {
            const activeLink = this.tocLinkTargets.find(link =>
                link.getAttribute('href') === `#${currentHeading.id}`
            )

            if (activeLink) {
                this.updateActiveLink(activeLink)
            }
        }
    }

    updateActiveLink(activeLink) {
        // Remove active styling from all links
        this.tocLinkTargets.forEach(link => {
            link.classList.remove('font-bold', 'text-logob-600')
            link.classList.add('text-gray-700')
        })

        // Add active styling to current link
        if (activeLink) {
            activeLink.classList.remove('text-gray-700')
            activeLink.classList.add('font-bold', 'text-logob-600')
        }
    }

    throttle(func, wait) {
        let timeout
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout)
                func(...args)
            }
            clearTimeout(timeout)
            timeout = setTimeout(later, wait)
        }
    }
}


